import React,{useEffect,useState} from 'react';
import { getToken, getUser, removeUserSession } from '../utils/Common';
import { useHistory,useParams,useLocation} from "react-router-dom";
import { Sun, Moon } from 'lucide-react';
import Swal from 'sweetalert2'

function Header() {
// Simple theme management with localStorage
const [theme, setTheme] = useState(() => {
  return localStorage.getItem('theme') || 'light';
});

const toggleTheme = () => {
  const newTheme = theme === 'light' ? 'dark' : 'light';
  setTheme(newTheme);
  localStorage.setItem('theme', newTheme);
  
  // Apply theme class to document
  if (newTheme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};

// Apply theme on mount
useEffect(() => {
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}, [theme]);
const history = useHistory();
const [side, setSide] = useState();    

// Session (encrypted)
const userData = getUser() || {};
const uName = userData.name;
const uDept = userData.nm_department;
const uRole = userData.role_name;
const uAva = userData.img_user;


const signOut = () => {
    Swal.fire({
      title: 'Do you want to logout  ?',
      text: "This process will direct to login page",
      showDenyButton: true,
      confirmButtonText: 'Sure',
      denyButtonText: `Cancel`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        removeUserSession();
        history.replace('/');
        
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

useEffect(() => {
   if(side) {
    document.body.classList.add('toggle-sidebar')
   } else{
    document.body.classList.remove('toggle-sidebar')
   }   
}, [side]);

return (
<>
    <header id="header" className="header fixed-top d-flex align-items-center dark:bg-gray-700">

    <div className="d-flex align-items-center justify-content-between">
        <i className="bi bi-list toggle-sidebar-btn" style={{marginRight:"2%"}} onClick={()=>setSide(!side)}></i>
    </div>

    {/* <div className="search-bar">
        <form className="search-form d-flex align-items-center" >
            <input type="text" name="query" placeholder="Search" title="Enter search keyword" />
            <button type="submit" title="Search"><i className="bi bi-search"></i></button>
        </form>
    </div> */}

    <nav className="header-nav ms-auto ">
    <ul className="d-flex align-items-center">

        {/* Theme Toggle Switch */}
        <li className="nav-item me-3">
            <button 
                onClick={toggleTheme}
                style={{
                    position: 'relative',
                    width: '60px',
                    height: '30px',
                    backgroundColor: theme === 'light' ? '#e2e8f0' : '#4a5568',
                    borderRadius: '15px',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    padding: '0',
                    outline: 'none'
                }}
                title={theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
            >
                <span
                    style={{
                        position: 'absolute',
                        top: '3px',
                        left: theme === 'light' ? '3px' : '33px',
                        width: '24px',
                        height: '24px',
                        backgroundColor: '#ffffff',
                        borderRadius: '50%',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                >
                    {theme === 'light' ? (
                        <Sun style={{ width: '14px', height: '14px', color: '#f59e0b' }} />
                    ) : (
                        <Moon style={{ width: '14px', height: '14px', color: '#6366f1' }} />
                    )}
                </span>
            </button>
        </li>

        {/* <li className="nav-item dropdown">

            <a className="nav-link nav-icon" data-bs-toggle="dropdown">
                <i className="bi bi-bell"></i>
                <span className="badge bg-primary badge-number">4</span>
            </a>

            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
                <li className="dropdown-header">
                You have 4 new notifications
                <a href="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
                </li>
                <li>
                <hr className="dropdown-divider" />
                </li>

                <li className="notification-item">
                <i className="bi bi-exclamation-circle text-warning"></i>
                <div>
                    <h4>Lorem Ipsum</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>30 min. ago</p>
                </div>
                </li>

                <li>
                <hr className="dropdown-divider" />
                </li>

                <li className="notification-item">
                <i className="bi bi-x-circle text-danger"></i>
                <div>
                    <h4>Atque rerum nesciunt</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>1 hr. ago</p>
                </div>
                </li>

                <li>
                <hr className="dropdown-divider" />
                </li>

                <li className="notification-item">
                <i className="bi bi-check-circle text-success"></i>
                <div>
                    <h4>Sit rerum fuga</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>2 hrs. ago</p>
                </div>
                </li>

                <li>
                <hr className="dropdown-divider"/>
                </li>

                <li className="notification-item">
                <i className="bi bi-info-circle text-primary"></i>
                <div>
                    <h4>Dicta reprehenderit</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>4 hrs. ago</p>
                </div>
                </li>

                <li>
                <hr className="dropdown-divider" />
                </li>
                <li className="dropdown-footer">
                <a href="#">Show all notifications</a>
                </li>

            </ul>

        </li> */}

        {/* <li className="nav-item dropdown">

        <a className="nav-link nav-icon" data-bs-toggle="dropdown">
            <i className="bi bi-chat-left-text"></i>
            <span className="badge bg-success badge-number">3</span>
        </a>

        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages">
            <li className="dropdown-header">
            You have 3 new messages
            <a href="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
            </li>
            <li>
            <hr className="dropdown-divider" />
            </li>

            <li className="message-item">
            <a href="#">
                <img src="assets/img/messages-1.jpg" alt="" className="rounded-circle" />
                <div>
                <h4>Maria Hudson</h4>
                <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                <p>4 hrs. ago</p>
                </div>
            </a>
            </li>
            <li>
            <hr className="dropdown-divider" />
            </li>

            <li className="message-item">
            <a href="#">
                <img src="assets/img/messages-2.jpg" alt="" className="rounded-circle" />
                <div>
                <h4>Anna Nelson</h4>
                <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                <p>6 hrs. ago</p>
                </div>
            </a>
            </li>
            <li>
            <hr className="dropdown-divider" />
            </li>

            <li className="message-item">
            <a href="#">
                <img src="assets/img/messages-3.jpg" alt="" className="rounded-circle" />
                <div>
                <h4>David Muldon</h4>
                <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                <p>8 hrs. ago</p>
                </div>
            </a>
            </li>
            <li>
            <hr className="dropdown-divider" />
            </li>

            <li className="dropdown-footer">
            <a href="#">Show all messages</a>
            </li>

        </ul>

        </li> */}

        <li className="nav-item dropdown pe-3">

        <a className="nav-link nav-profile d-flex align-items-center pe-0" data-bs-toggle="dropdown">
            <img src={uAva} alt="Profile" className="rounded-circle" />
            <span className="d-none d-md-block dropdown-toggle ps-2">{uName}</span>
        </a>

        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
            <li className="dropdown-header">
                <h6>{uName}</h6>
                <span>{uRole}</span>
            </li>
            <li>
                <hr className="dropdown-divider" />
            </li>


            <li>
                <a className="dropdown-item d-flex align-items-center" >
                    <i className="bi bi-gear"></i>
                    <span>Account Settings</span>
                </a>
            </li>
            <li>
            <hr className="dropdown-divider" />
            </li>

            <li>
                <a className="dropdown-item d-flex align-items-center" >
                    <i className="bi bi-question-circle"></i>
                    <span>Need Help?</span>
                </a>
            </li>
            <li>
            <hr className="dropdown-divider" />
            </li>

            <li>
                <a className="dropdown-item d-flex align-items-center" onClick={()=>signOut()}>
                    <i className="bi bi-box-arrow-right"></i>
                    <span>Sign Out</span>
                </a>
            </li>

        </ul>

        </li>

    </ul>
    </nav>

    </header>
</>


)}

export default Header
